import React from 'react';
import './sidebar.css'

import {} from 'react-bootstrap';
import Code from './components/code/code';
import Title from './components/title/title';
import Content from './components/content/content';

const par1 = "Welcome to Delphi Knight. This is a demo platform to showcase our idea and more features will be added in later versions of the application. For now we will take you on a scenario lesson and get a feel for how the platform works... Let's get Coding!"

const par2 = " The code currently in the editor is the default code that delphi uses to create forms. Do not remove this code."

const par3 = " For this short lesson we are going to add a label to the form and see result. Add the following code ino the editor under TForm1 = class(TForm)"

const code1 = "Label1: TLabel;"

const par4 = " This code adds a label to the components list but we cannot see the label yet because it is not added to the form. Now add the following code."

const code2 = " Label1.Caption := 'Hello World'; "

const par5 = "Now when the button is clicked the label will change but unfortunatly this demo does not have functioning components but click run to see a visual of the output"

export default function (){
    return(
        <div className='sidebar'>
            <Title />
            <Content content={ par1 } />
            <Content content={ par2 } />
            <Content content={ par3 } />
            <Code code={ code1 } />
            <Content content={ par4 } />
            <Code code={ code2 } />
            <Content content={ par5 } />
            
        </div>
    )
}